// extracted by mini-css-extract-plugin
export default {"root":"styles_root__10AmW","header":"styles_header__1ItH9","buttons":"styles_buttons__2SDZc","content":"styles_content__3Chzm"};